import styled, { css } from 'styled-components';
import Link from 'next/link';
import { Typography } from '../../ui/Typography';
import {
  fillFlatNewIconWithColor,
  fillVillaIconWithColor,
  FlexCenterAligned,
  FlexibleDiv,
  transitionStyles
} from '../../../styled/common';
import { CategoryContainerProps } from './types';

export const CategoriesContainer = styled(FlexibleDiv)`
  align-items: flex-start;
  justify-content: flex-start;
  overflow-x: auto;
  width: 100%;
  margin: 20px 0;
  gap: 10px;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: max-content;
  }
`;

const containerStateStyles = (color: string) => css`
  span {
    ${transitionStyles('color')}
    color: ${color};
  }

  &:nth-of-type(1),
  &:nth-of-type(4),
  &:nth-of-type(6),
  &:nth-of-type(7) {
    svg path,
    svg rect {
      ${transitionStyles('stroke')}
      stroke: ${color};
    }
  }

  &:nth-of-type(2) {
    ${fillFlatNewIconWithColor(color)};
  }

  &:nth-of-type(3) {
    ${fillVillaIconWithColor(color)};
  }

  &:nth-of-type(5) {
    svg path {
      fill: ${color};
      ${transitionStyles('fill')}
    }
  }
`;

const categoryContainerStyles = (isSelected: boolean) => css`
  height: 48px;
  padding: 4px 15px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 100px;
  cursor: pointer;
  ${transitionStyles('background-color')};
  -webkit-tap-highlight-color: transparent;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      ${({ theme }) => containerStateStyles(theme.colors.systemColors.blue)}
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.systemColors.blue};
    ${({ theme }) => containerStateStyles(theme.colors.text.white)}
  }

  ${isSelected &&
  css`
    background-color: ${({ theme }) => theme.colors.systemColors.blue};
    ${({ theme }) => containerStateStyles(theme.colors.text.white)}
  `}

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }

  -webkit-tap-highlight-color: transparent;
`;

export const CategoryContainer = styled(
  FlexCenterAligned
)<CategoryContainerProps>`
  gap: 5px;
  ${({ $isSelected }) => categoryContainerStyles($isSelected)};
`;

export const CategoryLinkContainer = styled(Link)<CategoryContainerProps>`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  ${({ $isSelected }) => categoryContainerStyles($isSelected)};
`;

export const CategoryText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.primary};
`;
